import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

function navbarBottom() {
  const navbar = document.querySelector('.navbar-header');
  return navbar ? Math.ceil(navbar.getBoundingClientRect().bottom) : 72;
}

const SitesWebStickyHead = ({ children, className = 'sw-grid' }) => {
  const headRef = useRef(null);
  const stuckRef = useRef(null);
  const [stuck, setStuck] = useState(null);

  useEffect(() => {
    const update = () => {
      const head = headRef.current;
      const board = head?.closest('.sw-board');
      if (!head || !board || head.getBoundingClientRect().height === 0) {
        if (stuckRef.current) {
          stuckRef.current = null;
          setStuck(null);
        }
        return;
      }

      const top = navbarBottom();
      const headRect = head.getBoundingClientRect();
      const boardRect = board.getBoundingClientRect();
      const visible = headRect.top < top - 1 && boardRect.bottom > top + headRect.height;
      const next = visible
        ? { top, left: headRect.left, width: headRect.width }
        : null;
      const prev = stuckRef.current;
      const same = (!next && !prev)
        || (next && prev && next.top === prev.top && next.left === prev.left && next.width === prev.width);
      if (same) return;
      stuckRef.current = next;
      setStuck(next);
    };

    update();
    const onScroll = () => window.requestAnimationFrame(update);
    window.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll, { capture: true });
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return (
    <>
      <div ref={headRef} className={`${className} sw-head-row`}>
        {children}
      </div>
      {stuck ? createPortal(
        <div
          className={`${className} sw-head-row sw-head-row--fixed`}
          style={{ top: stuck.top, left: stuck.left, width: stuck.width }}
        >
          {children}
        </div>,
        document.body,
      ) : null}
    </>
  );
};

export default SitesWebStickyHead;
